import { SEOHead } from '@/components/@next/SEOHead';
import { AboutPage } from '../containers/aboutPage';
import NextApp from '../NextApp';

export default function About() {
  return (
    <NextApp>
      <SEOHead
        title="About Us"
        description="Secure Trade Club (STC) is an innovative platform designed with the Serious Collector
              in mind."
      ></SEOHead>
      <AboutPage />
    </NextApp>
  );
}
